export enum ImportKsefXmlErrorCode {
    XML_VALIDATION_ERROR = 'XML_VALIDATION_ERROR',
    XML_URI_NOT_FOUND = 'XML_URI_NOT_FOUND',
    UNKNOWN_SYSTEM_CODE = 'UNKNOWN_SYSTEM_CODE',
    INCORRECT_ISSUE_DATE_ERROR = 'INCORRECT_ISSUE_DATE_ERROR',
    INCORRECT_ORIGINAL_NUMBER_ERROR = 'INCORRECT_ORIGINAL_NUMBER_ERROR',
    INCORRECT_SELLER_TIN_ERROR = 'INCORRECT_SELLER_TIN_ERROR',
    INCORRECT_DOCUMENT_KIND_ERROR = 'INCORRECT_DOCUMENT_KIND_ERROR',
    DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND',
    KSEF_DOCUMENT_WAS_NOT_IMPORTED = 'KSEF_DOCUMENT_WAS_NOT_IMPORTED',
    UPDATE_FILE_ERROR = 'UPDATE_FILE_ERROR',
    DOCUMENT_IS_SENT_TO_KSEF = 'DOCUMENT_IS_SENT_TO_KSEF',
    OPTIMISTIC_LOCKING = 'OPTIMISTIC_LOCKING'
}
